<template>
  <div>
    <h5>Historia zmiany ceny</h5>
    
    <div v-if="loading">
      Ładowanie...
    </div>

    <div class="price-history p-3" v-else-if="history.length != 0">
      <ol class="twoqbs-list-price-history">      
         <li class="twoqbs-list-price-history-li" v-for="(item, index) in filteredHistory" :key="index">
    {{ formatDate(item.date_modified) }} | {{ formatPrice(item.after.price) }} 
  </li>
      </ol>
    </div>

    <div v-else>
      Brak historii do wyświetlenia
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    flatId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      history: [],
      loading: true // nowy stan loadera
    };
  },
  mounted() {
    this.fetchPriceHistory();
  },
  methods: {
    async fetchPriceHistory() {
      try {
          // const res = await axios.get(`https://test.2qbs.pl/wp-json/twoqbs/v1/flat/${this.flatId}` //-> do testów lokalnych
        const res = await axios.get(window.location.origin + `/wp-json/twoqbs/v2/flat/${this.flatId}?nocahe=` + new Date().getTime()
        );

       if (res.data && res.data.price_change_history) {
  const arr = res.data.price_change_history?.realestate?.price_history;
  this.history = Array.isArray(arr) ? arr : [];
} else {
  this.history = [];
}
      } catch (err) {
        console.error("Błąd pobierania historii cen:", err);
        this.history = [];
      } finally {
        this.loading = false; // po zakończeniu pobierania, ukrywamy loader
      }
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("pl-PL");
    },
    formatPrice(price) {
      if (!price) return "-";
      return Number(price).toLocaleString("pl-PL", {
        style: "currency",
        currency: "PLN",
        minimumFractionDigits: 2
      });
    }
  },
  computed: {
  filteredHistory() {
     if (!Array.isArray(this.history)) return [];
  const minDate = new Date('2025-09-11');
  return this.history.filter(item => {
    if (!item.date_modified) return false;
    return new Date(item.date_modified) >= minDate;
  });
  }
},
};
</script>

<style scoped>
.price-history {
  background: #f9f9f9;
  border-radius: 8px;
}
</style>
